import { get } from 'lodash'
import { constants } from './constants'

export const getFixedStatusStr = fixedStatus => get(constants.FixedStatusMappping, fixedStatus, '-')
